import * as ActionTypes from './actionTypes'
import * as selectors from "./selectors"
import {getOpenCustomerId, getOpenCustomerName} from "./selectors"
import {EntityType} from 'constants'
import actionsGenerator from '../comments/actionsGenerator'
import commentsActionGenerator from '../comments/commentsActionsGenerator'
import {createAction} from 'redux-actions'
import messageResource from '../../messageResource'
import rpcCall from '../../util/rpc/rpcCalls'
import {CopySettingsTypes} from '../components/constants'
import {copyTasksToProjectsAction, setBulkOperationProgress} from '../../taskManagement/bulkOperations/actions'
import CustomerStore from '../../store/CustomerStore'
import {addCustomer, addProjects} from '../../entities/actions'
import {customerFromRpc, projectFromRpc} from '../../taskManagement/utils'
import ProjectStore from '../../store/ProjectStore'
import {toggleLoadingMoire} from '../../taskManagement/common/actions'
import {toast} from '../../toasts/actions'
import {separateProjectCopySettings, separateTaskCopySettings} from '../project/actions'
import {NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION, NO_SUCH_CUSTOMER_EXCEPTION} from '../../taskManagement/common/ExceptionsTypes'
import {Exceptions} from '../../common/constants'
import {copyCustomerRpcErrorHandler} from './utils'
import {copyToClipboard} from '../../atBrowserUtils'
import {createLinkToCustomer} from '../urlHelper/utils'

export const setOpenCustomer = createAction(ActionTypes.OPEN_CUSTOMER_SET)
export const setPanelOpenedFromUrl = createAction(ActionTypes.CUSTOMER_PANEL_OPENED_FROM_URL_SET)
export const setAllProjectsAssigned = createAction(ActionTypes.ALL_PROJECTS_ASSIGNED_SET)
export const setCanManageCustomer = createAction(ActionTypes.CAN_MANAGE_SET)

export const commentsActions = actionsGenerator({
    actionTypes: ActionTypes,
})

export const commentsServiceActions = commentsActionGenerator({
    actions: commentsActions,
    selectors: {
        ...selectors,
        getOpenEntityId: selectors.getOpenCustomerId
    },
    handleServiceError: (customerId, error) => handleServiceError(customerId, error),
    entityType: EntityType.CUSTOMER
})

export const openCustomerPanel = (customerId, fromUrl = false) => (dispatch, getState) => {
    const state = getState()

    const openCustomerId = selectors.getOpenCustomerId(state)

    if (openCustomerId !== customerId) {
        dispatch(setPanelOpenedFromUrl(fromUrl))
        dispatch(setOpenCustomer(customerId))
    } else {
        dispatch(closeCustomerPanel())
    }
}

export const closeCustomerPanel = () => dispatch => {
    dispatch(setOpenCustomer(null))
    dispatch(setPanelOpenedFromUrl(false))
}

export const reloadComments = commentsServiceActions.reloadComments

export const updateNewCommentText = text => (dispatch, getState) => {
    const state = getState()
    const customerId = getOpenCustomerId(state)
    if (text !== '') {
        dispatch(commentsActions.setNewComment({entityId: customerId, text}))
    } else {
        dispatch(commentsActions.removeNewComment(customerId))
    }
    dispatch(commentsServiceActions.saveEntityNewCommentsTextsInLocalStorage())
}

const handleServiceError = (customerId, error) => {
    if (error.getTextStatus() === 'rpc_customException') {
        switch (error.getErrorThrown().exception) {
            case 'com.actimind.actitime.services.impl.comments.NoSuchEntityException':
                alert(messageResource.getMessage('customer.edit.cannot_edit_deleted_concurrently'));
                window.location.reload();
                return true;
            case 'com.actimind.actitime.services.impl.comments.EntityNotAssignedException':
                alert(messageResource.getMessage('common.no_rights_for_operation_anymore'));
                window.location.reload();
                return true;
            case 'com.actimind.actitime.services.NoRightToEditHierarchyException':
                alert(messageResource.getMessage('common.no_rights_for_operation_anymore'));
                window.location.reload();
                return true;
            case 'com.actimind.actitime.services.impl.comments.NoSuchCommentException':
                alert(messageResource.getMessage('panel.common.comments.comment_concurrently_deleted'));
                return true;
        }
    }
    return false
}

export const getNameForCopyCustomer = (onSuccessCb = () => {}) => (dispatch, getState) => {
    rpcCall("CustomerInfoService.getCustomerNameWithVersion", [getOpenCustomerName(getState())],
    ).then((newCustomerName) => {
        onSuccessCb(newCustomerName)
    }).catch(() => {
        //
    })
}

export const copyCustomer = (customerName, copySettings, onSuccessCb = () => {}) => (dispatch, getState) => {
    dispatch(toggleLoadingMoire(true))
    dispatch(setBulkOperationProgress(null))
    const copyFromCustomerId = getOpenCustomerId(getState())
    rpcCall("CustomerInfoService.copyCustomer", [
            customerName,
            copyFromCustomerId,
            !!copySettings[CopySettingsTypes.COPY_CUSTOMER_DESCRIPTION],
            separateProjectCopySettings(copySettings),
        ],
        copyCustomerRpcErrorHandler
    ).then((result) => {
        const customer = customerFromRpc(result.customer)
        CustomerStore.addFirst(customer)
        dispatch(addCustomer(customer))

        if (result.projects) {
            const projects = result.projects.list.map((data) => projectFromRpc(data))
            ProjectStore.mergeAll(projects)
            dispatch(addProjects(projects))
        }

        if (result.taskIds.length > 0) {
            dispatch(copyTasksToProjectsAction(
                result.taskIds,
                result.projectsOldIdsToNewIds.map,
                copySettings,
                result.operationId,
            ))
        }

        dispatch(toggleLoadingMoire(false))

        const copyFromCustomerName = CustomerStore.get(copyFromCustomerId).name
        dispatch(toast(messageResource.getMessage("customer.copy.toast", [customer.name, copyFromCustomerName])))

        if (customerName !== customer.name)
            dispatch(toast(messageResource.getMessage('customer.copy.duplicate_name.toast')))

        onSuccessCb()
    }).catch((err) => {
        switch (err.getException()) {
            case NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION:
                alert(messageResource.getMessage("customer.error.copy.no_manage_scope_right"))
                window.location.reload()
                break
            case NO_SUCH_CUSTOMER_EXCEPTION:
                alert(messageResource.getMessage("customer.error.copy.customer_deleted"))
                window.location.reload()
                break
            case Exceptions.NO_RIGHTS_FOR_REMOTE_CALL_EXCEPTION:
                alert(messageResource.getMessage("customer.error.copy.entire_scope_revoked"))
                window.location.reload()
                break
        }
    })
}

export const copyLinkTo = () => (dispatch, getState) => {
    const customerId = getOpenCustomerId(getState())
    copyToClipboard(createLinkToCustomer(customerId), () => {
        dispatch(toast(messageResource.getMessage('panel.common.link_copied')))
    })
}



// WEBPACK FOOTER //
// ./web/js/panels/customer/actions.js